import { useState, useEffect } from 'react'
import { Radio, RadioGroup, Stack } from '@chakra-ui/react'


export default function InsightPanelTypeRadioSelect({ enableSegments, setSelectedValue }) {

    const [internalSelectedValue, setInternalSelectedValue] = useState('distance')

    useEffect(() => {
        if (enableSegments) {
            setInternalSelectedValue('segments')
        } else {
            setInternalSelectedValue('distance')
        }
    }, [enableSegments])

    useEffect(() => {
        setSelectedValue(internalSelectedValue)
    }, [internalSelectedValue])

    return (
        <RadioGroup onChange={setInternalSelectedValue} value={internalSelectedValue}>
            {enableSegments && <Radio value='segments' size='sm' padding={1}>Segments</Radio>}
            <Radio value='distance' size='sm' padding={1}>Distance</Radio>
            <Radio value='duration' size='sm' padding={1}>Duration</Radio>
        </RadioGroup>
    )
}